<template>
<div class="chapter">
<div class="inner_page">
<a id="page_3"></a>
<h1 class="title"><span class="bold"><span class="ash">Pastels</span></span> <span class="hf">for the</span></h1>
<h1 class="title1"><span class="bold">Absolute Beginner</span></h1>
<p class="author"><span class="ash1"><span class="bold">REBECCA DE MENDONÇA</span></span></p>
<div class="img_container">
<img alt="Image" src="images/pub.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Title.vue?7ecb4594